import { ReactNode, useState } from "react";

import ToggleChevronIcon from "@components/layout/toggle-chevron-icon";
import Tooltip from "@components/tooltip/tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

export const CollapsibleGroupPanel = ({
  groupLabel,
  numComments,
  numResponses,
  children,
  defaultExpanded = true,
  isHidden = false,
}: {
  groupLabel: string;
  numComments: number;
  numResponses: number;
  children: ReactNode;
  defaultExpanded?: boolean;
  isHidden?: boolean;
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="border rounded-lg bg-gray-50 mb-3 last:mb-0">
      <div
        className="px-4 py-3 rounded-lg hover:bg-gray-100 cursor-pointer"
        role="button"
        onClick={() => !isHidden && setExpanded(!expanded)}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="font-semibold text-gray-900">{groupLabel}</div>
            <div className="text-xs py-0.5 px-2 bg-gray-200 rounded-md">
              {numComments} / {numResponses}
            </div>
            {!isHidden && <ToggleChevronIcon expanded={expanded} />}
          </div>
          {isHidden && (
            <div className="flex items-center gap-1.5 text-sm text-gray-500">
              <Tooltip text="To keep identities anonymous, we cannot display data when there are fewer than 3 people responding.">
                <span className="flex items-center gap-1.5">
                  <TopicflowIcon type="info" className="h-4 w-4" />
                  <span>Not enough responses to show results</span>
                </span>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
      {!isHidden && expanded && (
        <div className="px-4 pb-4 pt-2">{children}</div>
      )}
    </div>
  );
};
